<script setup lang="ts">
// 修改导入语句，直接从Vue和Nuxt导入
import { ref, watch, onMounted, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import { useLocale } from '~/composables/useLocale'
import { supportedLocales } from '~/i18n/config';

const { locale } = useI18n();
const appIsReady = ref(false);

// 初始化语言设置
const { initLocale } = useLocale()

// 优化挂载流程，将关键初始化提前
onMounted(async () => {
  // 立即初始化关键功能
  initLocale();
  
  // 使用nextTick等待DOM更新
  await nextTick();
  
  // 使用requestAnimationFrame延迟非关键初始化
  if (typeof window !== 'undefined') {
    Promise.resolve().then(() => {
      setupLocaleWatcher();
      appIsReady.value = true;
    });
  }
});

// 将语言监听逻辑提取到函数
function setupLocaleWatcher() {
  // 监听语言变化，保存到localStorage
  watch(locale, (newLocale: string) => {
    if (typeof window !== 'undefined' && supportedLocales.includes(newLocale as any)) {
      localStorage.setItem('locale', newLocale);
    }
  });
}
</script>

<template>
  <div class="dark">
    <!-- 使用NuxtLayout包装内容 -->
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    
    <!-- 全局 Toast 事件监听器 - 懒加载方式 -->
    <GlobalToastListener v-if="appIsReady" />

  </div>
</template>

<style>
/* 内联关键CSS，确保首屏渲染时关键样式立即可用 */
:root {
  --bg-color: #030712;
  --text-color: #f9fafb;
}

/* 隐藏Nuxt的默认链接和调试信息 */
.__nuxt-error-page,
.nuxt-progress,
.nuxt-loading,
.nuxt-link-active {
  display: none !important;
}

/* 确保页面背景始终是深色的 */
html, body {
  background-color: var(--bg-color) !important; /* dark:bg-gray-950 */
  color: var(--text-color);
  margin: 0;
  padding: 0;
  text-rendering: optimizeSpeed;
}

/* 添加首屏关键样式 */
.dark {
  color-scheme: dark;
  min-height: 100vh;
  width: 100%;
}
</style>
